import React, { useState } from 'react';
import Hero from '../components/Hero';
import Trust from '../components/Trust';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Calculator from '../components/Calculator';
import EmailCapture from '../components/EmailCapture';
import AIAdvisor from '../components/AIAdvisor';
import FAQ from '../components/FAQ';

const Home = () => {
  const [calculationResults, setCalculationResults] = useState(null);

  return (
    <>
      <Hero />
      <Trust />
      <Features />
      <Calculator onResultsUpdate={setCalculationResults} />
      <EmailCapture results={calculationResults} />
      <HowItWorks />
      <AIAdvisor />
      <FAQ />
      
      {/* Final CTA Section */}
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-brand-600 rounded-[3rem] p-12 md:p-20 text-center text-white relative overflow-hidden shadow-2xl shadow-brand-600/30">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-20 -mt-20 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-400/20 rounded-full -ml-20 -mb-20 blur-3xl"></div>
            
            <div className="relative z-10">
              <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight">
                Ready to secure your future?
              </h2>
              <p className="text-xl text-brand-100 mb-10 max-w-2xl mx-auto font-medium">
                Start planning your EPF savings today — it takes less than 10 seconds and it's completely free.
              </p>
              <button 
                onClick={() => document.getElementById('calculator')?.scrollIntoView({ behavior: 'smooth' })}
                className="inline-flex items-center justify-center px-10 py-5 rounded-2xl bg-white text-brand-600 font-bold text-xl hover:bg-brand-50 transition-all hover:scale-105 active:scale-95 shadow-xl"
              >
                Calculate My EPF Now
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;